import Vue from 'vue';
export default Vue.extend({
    methods: {
        showError(text) {
            this.$toasted.show(text, { position: 'bottom-center', duration: '3000', type: 'error', fullWidth: true });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/MessageModule.ts
// module id = 59
// module chunks = 1